import { getAuthTokenStorage } from 'common/auth/authService';
import axiosNonTokenInstance from 'integration/axiosNonTokenInstance';
import axiosInstance from 'integration/axiosInstance';
import {
  InvestorAccountDto,
  LoginDto,
  SignInResponse,
  TokenDto,
} from './models';

export const AuthAPI = {
  signIn: (data: LoginDto) => {
    return axiosNonTokenInstance.post<SignInResponse>(
      '/api/investor/sign-in/email',
      data
    );
  },
  refreshToken: async () => {
    const { refreshToken, userId } = await getAuthTokenStorage();

    return axiosNonTokenInstance.post<TokenDto>('/api/investor/refresh-token', {
      refreshToken,
      userId,
    });
  },
  getInvestorAccount: () => {
    return axiosInstance.get<InvestorAccountDto>('/api/investor/account');
  },
  logout: () => {
    return axiosInstance.post<InvestorAccountDto>('/api/investor/logout');
  },
};
